export default "__VITE_ASSET__BBaUO0UA__"